@if (src$ | async; as src) {
  <img [class]="classNames" [alt]="alt" src="{{ src }}" />
}
